import api from "../utils/API";

// Base URL for your API
export const authService = {
  login: async (payload) => {
    try {
      const response = await api.post("/admin/auth/login", payload);
      return response?.data;
    } catch (error) {
      return error.response.data;
    }
  },

  resetPassword: async (payload) => {
    try {
      const response = await api.post("/admin/auth/reset-password", payload);
      return response.data;
    } catch (error) {
      return error.response.data;
    }
  },

  forgotPassword: async (payload) => {
    try {
      const response = await api.put("/admin/auth/forgot-password", payload);
      return response.data;
    } catch (error) {
      return error.response.data;
    }
  },

  OTPRequest: async (payload) => {
    try {
      const response = await api.put("/admin/auth/forgot-password-otp", payload);
      return response.data;
    } catch (error) {
      return error.response.data;
    }
  },
  OTPVerify: async (payload) => {
    try {
      const response = await api.put("/admin/auth/verify-forgot-password-otp", payload);
      return response.data;
    } catch (error) {
      return error.response.data;
    }
  },
  changePassword: async (payload) => {
    try {
      const response = await api.put("/admin/auth/set-password", payload);
      return response.data;
    } catch (error) {
      return error.response.data;
    }
  },
};
